/* eslint-disable */
import { PluginContainerData, Media } from './common.js';

export interface ShapeData {
  /** Styling for the shape's container. */
  containerData?: PluginContainerData;
  /** Shape file details. */
  shape?: Media;
  /** Styling for the shape. */
  styles?: ShapeData_Styles;
}

export interface ShapeData_Styles {
  /** Shape fill color as a hexadecimal value. */
  color?: string;
  /** Map of original color keys to their new color values. */
  colors: { [key: string]: string };
}

export interface ShapeData_Styles_ColorsEntry {
  key: string;
  value: string;
}

const baseShapeData: object = {};

export const ShapeData = {
  fromJSON(object: any): ShapeData {
    const message = { ...baseShapeData } as ShapeData;
    message.containerData =
      object.containerData !== undefined && object.containerData !== null
        ? PluginContainerData.fromJSON(object.containerData)
        : undefined;
    message.shape =
      object.shape !== undefined && object.shape !== null
        ? Media.fromJSON(object.shape)
        : undefined;
    message.styles =
      object.styles !== undefined && object.styles !== null
        ? ShapeData_Styles.fromJSON(object.styles)
        : undefined;
    return message;
  },

  toJSON(message: ShapeData): unknown {
    const obj: any = {};
    message.containerData !== undefined &&
      (obj.containerData = message.containerData
        ? PluginContainerData.toJSON(message.containerData)
        : undefined);
    message.shape !== undefined &&
      (obj.shape = message.shape ? Media.toJSON(message.shape) : undefined);
    message.styles !== undefined &&
      (obj.styles = message.styles
        ? ShapeData_Styles.toJSON(message.styles)
        : undefined);
    return obj;
  },
};

const baseShapeData_Styles: object = {};

export const ShapeData_Styles = {
  fromJSON(object: any): ShapeData_Styles {
    const message = { ...baseShapeData_Styles } as ShapeData_Styles;
    message.color =
      object.color !== undefined && object.color !== null
        ? String(object.color)
        : undefined;
    message.colors = Object.entries(object.colors ?? {}).reduce<{
      [key: string]: string;
    }>((acc, [key, value]) => {
      acc[key] = String(value);
      return acc;
    }, {});
    return message;
  },

  toJSON(message: ShapeData_Styles): unknown {
    const obj: any = {};
    message.color !== undefined && (obj.color = message.color);
    obj.colors = {};
    if (message.colors) {
      Object.entries(message.colors).forEach(([k, v]) => {
        obj.colors[k] = v;
      });
    }
    return obj;
  },
};

const baseShapeData_Styles_ColorsEntry: object = { key: "", value: "" };

export const ShapeData_Styles_ColorsEntry = {
  fromJSON(object: any): ShapeData_Styles_ColorsEntry {
    const message = {
      ...baseShapeData_Styles_ColorsEntry,
    } as ShapeData_Styles_ColorsEntry;
    message.key =
      object.key !== undefined && object.key !== null ? String(object.key) : "";
    message.value =
      object.value !== undefined && object.value !== null
        ? String(object.value)
        : "";
    return message;
  },

  toJSON(message: ShapeData_Styles_ColorsEntry): unknown {
    const obj: any = {};
    message.key !== undefined && (obj.key = message.key);
    message.value !== undefined && (obj.value = message.value);
    return obj;
  },
};
